export default "__VITE_ASSET__001d5776__"